import { AdviseProductType } from '../../../types/advise';
import { ccaasProductType } from './ccaas';

// Product type registry — add new product types here
const productTypeRegistry: Record<string, AdviseProductType> = {
  ccaas: ccaasProductType
};

export const getProductType = (id: string): AdviseProductType | undefined => productTypeRegistry[id];

export const getAllProductTypes = (): AdviseProductType[] => Object.values(productTypeRegistry);

export const getProductTypeIds = (): string[] => Object.keys(productTypeRegistry);
